import { useEffect, useState } from 'react'
import { createValidMenuList } from '../../../../shopPage2/TestOrder/_utils/createValidMenuList'
import { GroupBarTablet } from '../../../../shopPage2/TestOrder/SectionMenu/GroupBarTablet'
import { MenuItemsTablet } from '../../../../shopPage2/TestOrder/SectionMenu/MenuItemsTablet'
import { TestOrderModal } from '../../../../shopPage2/components/TestOrder/TestOrderModal2'
import { createOrderDataDpos } from '../../../../../lib-pos/sendOrder'
import {  
  onlposCreateOrderStatus2,
  onlposUpdateOrderStatus2,
} from '../../../lib/api-onlpos'

export function MenuPannel(props) {
  const {
    shopInfo,
    itemList,
    itemOptions,
    orderList,
    selectedTableInfo,
    updateOrderList,
  } = props

  const [showDetailPage, setShowDetailPage] = useState(false)
  const [selectedItem, setSelectedItem] = useState({})
  const [groups, setGroups] = useState([])
  const [orderForTable, setOrderForTable] = useState(null)

  // console.log('selectedTableInfo', selectedTableInfo)
  // console.log('selectedItem', selectedItem)
  // console.log('groups', groups)
  // console.log('orderList', orderList)

  useEffect(() => {
    if (itemOptions.groupList) {
      const res = createValidMenuList({
        shopInfo,
        itemList,
        itemOptions2: itemOptions,
      })
      setGroups(res.menuList)
    }

    const tableOrders = orderList.filter(
      (o) => o.orderId === selectedTableInfo.tableCode,
    )
    // console.log(selectedTableInfo.tableCode, tableOrders)
    if (tableOrders.length > 0) setOrderForTable(tableOrders[0])
  }, [itemOptions, orderList])

  const createOrder = async (cartItem) => {
    try {
      // console.log('cartItem', cartItem.itemName, cartItem.price)

      // const cartItems = [cartItem]
      const orderInfo = createOrderDataDpos({
        shopInfo,
        cartItems: [cartItem],
        itemOptions2: itemOptions,
        tableNo: selectedTableInfo.tableNo,
        // token: '1234',
        // ver: 'v3',
      })

      // 각 order 시간 추가
      orderInfo.result.orderList.map(o=>{
        o.ct = Date.now()
        return null
      })
            
      // console.log('orderInfo', JSON.stringify(orderInfo.result, null, 2))
      // throw Error('test...')

      let res = {}
      let params = {}

      if (orderForTable) {
        const preOrderList = orderForTable.orderData?.orderList || []
        console.log('preOrderList', preOrderList)
        const newOrderList = [...preOrderList, ...orderInfo.result.orderList]

        const orderData = {
          ...orderInfo.result,
          orderList: newOrderList,
        }

        // console.log('final orderData', orderData)

        params = {
          shopInfo,
          tableCode: selectedTableInfo.tableCode,
          body: {
            orderData: JSON.stringify(orderData),
          },
        }
        res = await onlposUpdateOrderStatus2(params)
      } else {
        params = {
          shopInfo,
          tableCode: selectedTableInfo.tableCode,
          body: {
            orderData: JSON.stringify(orderInfo.result),
          },
        }

        res = await onlposCreateOrderStatus2(params)
      }

      if (res.err) throw Error(res.err.message)
      await updateOrderList()
    } catch (e) {
      alert(e.message)
    }
  }

  const allProps = {
    ...props,
    groups,
    setGroups,
    selectedItem,
    setSelectedItem,
    showDetailPage,
    setShowDetailPage,
    mode: 'ONL_POS',
  }

  const styles = {
    wrap: { padding: 5 },
  }

  return (
    <div style={styles.wrap}>
      <GroupBarTablet {...allProps} />
      <MenuItemsTablet {...allProps} />
      {showDetailPage && (
        <TestOrderModal
          {...allProps}
          item={selectedItem}
          visible={showDetailPage}
          setIsVisible={setShowDetailPage}

          // ONL_POS 에서만 사용되는 props
          mode="ONL_POS"
          updateOrder={createOrder}
        />
      )}
    </div>
  )
}
